<script lang="ts">
  import { modbusDebugEnabled } from '$lib/State.svelte';
  import * as Accordion from '$lib/components/ui/accordion/index.js';
  import { Checkbox } from '$lib/components/ui/checkbox/index.js';
  import { Label } from '$lib/components/ui/label/index.js';
  import logger from '$lib/logger';

  $effect(() => {
    if (modbusDebugEnabled.current === true) {
      logger.info('Modbus debug logging turned on');
      // Automatically turn off after 10 minutes
      setTimeout(() => {
        logger.info('Modbus debug timer expired.');
        modbusDebugEnabled.current = false;
      }, 1000 * 600);
    } else {
      logger.info('Modbus debug logging turned off');
      modbusDebugEnabled.startTime = null;
    }
  });
</script>

<Accordion.Item value="modbus-settings">
  <Accordion.Trigger>Modbus debug</Accordion.Trigger>
  <Accordion.Content>
    <div class="flex items-center space-x-2">
      <Checkbox
        id="modbus-debug"
        bind:checked={modbusDebugEnabled.current}
        aria-labelledby="modbus-debug-label"
      />
      <Label
        for="modbus-debug"
        class="text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        Turn on Modbus debugging for the next 10 minutes.
      </Label>
    </div>
    <div class="text-muted-foreground mt-2 text-xs">
      When enabled, extra Modbus communication logs will be output for troubleshooting any Modbus
      device.
    </div>
  </Accordion.Content>
</Accordion.Item>
